import { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { useLocale } from 'state/intl';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { JOULE_CONVERSION_DIFFERENCE, formatCalories as formatCaloriesUtil } from 'utils/menu';

export const useMenuCalories = () => {
  const { formatMessage, formatNumber } = useIntl();
  const { region } = useLocale();

  const enableNutritionDecimals = useFlag(LaunchDarklyFlag.ENABLE_NUTRITION_DECIMALS);
  const enableEUNutritionDisplay = useFlag(LaunchDarklyFlag.ENABLE_EU_NUTRITION_DISPLAY);

  const formatCalories = useCallback(
    (calories: number | string | null | undefined) => {
      const parsedCalories = typeof calories === 'number' ? calories : parseFloat(calories || '');

      if (isNaN(parsedCalories)) {
        return '';
      }

      const formattedCalories = formatCaloriesUtil(
        calories,
        formatMessage({ id: 'cal' }),
        region,
        enableNutritionDecimals
      );

      if (enableEUNutritionDisplay) {
        const caloriesInKCal = (formattedCalories || '').split(' ')[0];
        const caloriesInJoules = formatNumber(parsedCalories * JOULE_CONVERSION_DIFFERENCE, {
          maximumFractionDigits: enableNutritionDecimals ? 1 : 0,
        });

        const euFormattedNutritionText = formatMessage(
          { id: 'euNutritionValues' },
          {
            calories: formattedCalories,
            joules: `${caloriesInJoules} KJ`,
          }
        );

        return caloriesInKCal ? `${euFormattedNutritionText}` : '';
      }
      return formattedCalories;
    },
    [enableEUNutritionDisplay, enableNutritionDecimals, formatMessage, formatNumber, region]
  );
  return {
    formatCalories,
  };
};
